import { useSearchParams } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

/**
 * Custom hook to get user ID with proper fallback hierarchy
 * Priority: URL parameter > Auth user data > null
 */
export const useUserId = () => {
  const [searchParams] = useSearchParams()
  const { user } = useAuth()
  
  // Get user ID from URL parameter first
  const urlUserId = searchParams.get('user_id')
  
  // Fallback to auth user data
  let fallbackUserId = null
  if (user?.user_metadata?.customer_id) {
    fallbackUserId = user.user_metadata.customer_id
  } else if (user?.customer_id) {
    fallbackUserId = user.customer_id
  } else if (user?.id) {
    fallbackUserId = user.id
  }
  
  const userId = urlUserId || fallbackUserId
  
  return {
    userId,
    urlUserId,
    fallbackUserId,
    hasUserId: !!userId,
    isFromUrl: !!urlUserId
  }
}

export default useUserId
